import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  userEnquiry: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'user-enquiry' }),
}

export { paths }
